import React from 'react';
import { Redirect } from 'react-router-dom'

export default class BaseTablePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.data = [];
        this.state.isLoaded = false;
        this.state.ShowModal = false;
        this.state.editID = false;

        this.state.pageNumber = 1;
        this.state.pageSize = 20;

        this.state.searchData = null;

        this.handleChangePage = this.handleChangePage.bind(this);
        this.onModalFinished = this.onModalFinished.bind(this);
        this.onAddClick = this.onAddClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.onViewClick = this.onViewClick.bind(this);
        this.onSubmitSearchData = this.onSubmitSearchData.bind(this);

        this.onExcelButtonClick = this.onExcelButtonClick.bind(this);

        this.getExcelUrl = "/api/v1/pathtogetdata?offset=";

        this.timer=this.timer.bind(this);

        this.state.getExcel=0;

        this.getDataUrl = "/api/v1/pathtogetdata?offset=";
        this.className = "BaseTablePage";


        var token = localStorage.getItem('token');
        this.headers =
        {
            'Content-Type': 'application/json',
            'AuthorizationToken': token
        };

    //    console.log(this.headers);
        this.mode = "table";

        this.getinitilizedata=true;

        this.autoRefresh=false;
        this.autoRefreshInit=false;


        this.state.isReady=false;
    }
    onModalFinished(message) {


        console.log(message);
        this.state.successMessage = message;
        this.setState({ isLoad: false });
        this.mode = "table";
        this.componentDidMount();

    }

    onSubmitSearchData(e) {


        this.state.searchData = e;
        this.setState({ isLoaded: false });
        this.mode = "table";


        this.state.pageNumber = 1;
        this.state.pageSize = 20;
        this.componentDidMount();

    }

    onExcelButtonClick(e)
     {

        if( this.state.getExcel===1)
        {
            alert("در حال محاسبه");
            return ;
        }

        alert("درخواست شما با موفقیت ثبت شد");
        this.state.getExcel=1;
        this.state.searchData = e;
        console.log("get excel");
        fetch(this.getExcelUrl,
            {
                method: 'POST',
                body: JSON.stringify(this.state.searchData),
                headers: this.headers
            }).then(res => {

                this.status = res.status;

                if (res.status === 200) {                 
                    console.log("redirecting");
                  //  openInNewTab("/Report/" + result.address);
                  window.location.href = "/taskTable";
                  return;                  
                }

                res.json().then((result) => {

                    this.state.getExcel=0;
                    console.log(result);
             
                        alert(result.Value);
                    
                },
                    (error) => 
                    {
                        this.state.getExcel=0;
                        console.log(res);
                    }
                );
            }
            );
    }


    handleChangePage(pageNumber) {
        this.state.pageNumber = pageNumber;
        this.setState({ isLoaded: false });
        this.componentDidMount();
    }

    timer()
    {
        this.autoRefreshInit=true;
        this.componentDidMount();
    }
    componentWillUnmount()
    {  
        if(this.autoRefresh)
            clearInterval(this.state.intervalId);
    }
    componentDidMount()
    { 

        if(this.autoRefresh && this.autoRefreshInit==false)
        {
            console.log( "auto refresh:"+this.autoRefreshInit);
            this.autoRefreshInit=true;
            console.log("auto update init");
            var intervalId = setInterval(this.timer, 5000);
            this.setState({intervalId: intervalId});
        }
        if( this.getinitilizedata==false)
        {
            return;
        }
        var offset = (this.state.pageNumber - 1) * this.state.pageSize;

      //  console.log(this.getDataUrl + offset);

      this.setState({isReady:false});
      //this.state.isReady=false;
      
      
        if (this.state.searchData == null) {
            fetch(this.getDataUrl + offset,
                {
                    method: 'GET',
                    headers: this.headers
                }).then(res => {
                    this.status = res.status;
                  //  console.log(this.status);


                    if (this.status === 401) {
                        localStorage.setItem('token', null);
                        window.location.reload(false);

                    }

                    res.json().then((result) => {


                        if (this.status === 200) {

                            this.state.data = result.objects;
                            this.state.pageSize = result.pageSize;
                            this.state.offset = result.offset;
                            this.state.count = result.count;

                            this.state.successCode = result.successCode;
                            this.state.distinctMobile = result.distinctMobile;

                            this.state.isLoaded = true;
                            
                            this.setState({isReady:true});
                            //this.setState({});


                        }

                    },
                        (error) => 
                        {
                            this.setState({isReady:true});
                        }
                    );
                }
                );
        }
        else {

            fetch(this.getDataUrl + offset,
                {
                    method: 'POST',
                    body: JSON.stringify(this.state.searchData),
                    headers: this.headers
                }).then(res => {
                    this.status = res.status;


                    if (this.status === 401) {
                        localStorage.setItem('token', null);
                        window.location.reload(false);

                    }

                    res.json().then((result) => {

                        console.log("status:" + this.status);

                        if (this.status === 200) {

                            console.log(result.objects);

                            this.state.data = result.objects;
                            this.state.pageSize = result.pageSize;
                            this.state.offset = result.offset;
                            this.state.count = result.count;

                            this.state.successCode = result.successCode;
                            this.state.distinctMobile = result.distinctMobile;

                            this.state.isLoaded = true;
                            this.setState({isReady:true});


                        }
                        else
                        {
                            this.setState({isReady:true});
                        }

                    },
                        (error) => {
                            this.setState({isReady:true});
                        }
                    );
                }
                );

        }

    }
    onEditClick(id) {
        this.state.ShowModal = true;
        this.state.editID = id;
        this.mode = "edit";
        this.setState({});
    }

    onViewClick(id) {
        console.log("view click");
        this.state.ShowModal = true;
        this.state.editID = id;
        this.mode = "view";
        this.setState({});
    }
    onAddClick() {
        this.state.ShowModal = true;
        this.mode = "add";
        this.setState({});
    }
    onDeleteClick(id) {

    }



}
function openInNewTab(url) {
    var win = window.open(url, '');
    //win.focus();
}


// WEBPACK FOOTER //
// ./src/elements/BaseTablePage.js